import React, { useState, useEffect, useRef, ReactNode } from "react";
import classNames from "classnames";
//@ts-ignore
import cn from "mxcn";

import { Link, NavLink } from "react-router-dom";
import { PiCaretDownBold } from "react-icons/pi";
import { SearchAnywhereInput } from "../SearchAnywhere";
import { useBranding } from "../../context/BrandingContext";
import { HiMiniCheckBadge } from "react-icons/hi2";
import {
  RxCross1,
  RxDashboard,
  RxDividerVertical,
  RxExit,
  RxGear,
  RxHamburgerMenu,
  RxMagnifyingGlass,
  RxMixerVertical,
  RxPerson,
  RxPieChart,
} from "react-icons/rx";
import { useAuth } from "../../context/AuthContext";
import { RiRobot2Line } from "react-icons/ri";
import { get } from "lodash";
import {
  useEventListener,
  useHover,
  useOnClickOutside,
  useTimeout,
} from "usehooks-ts";
import { FaBell } from "react-icons/fa";
import { useAppContext } from "../../context/AppContext";
import { isBriterBridgesUser } from "../../utils/strings";
import { getCurrentPersona, setCurrentPersona } from "../../utils/persona";

export const Logo = () => {
  const { logoSrc, logoAlt } = useBranding();
  return <img src={logoSrc} alt={logoAlt} className="max-h-[30px] py-1" />;
};

export const LogoDark = () => {
  const { logoSrc, logoAlt } = useBranding();
  return <img src={logoSrc} alt={logoAlt} className="max-w-[80px] py-1" />;
};

const TopNavLink = ({
  path,
  title,
  hasChildren = false,
  children,
}: {
  path: string;
  title: string;
  hasChildren?: boolean;
  children?: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const hovering = useHover(ref);

  useEffect(() => {
    setIsOpen(hovering);
  }, [hovering]);
  return (
    <div className="relative z-[51]" ref={ref}>
      <NavLink
        className={({ isActive }) => {
          const cls = classNames({
            "xl:border-b-2 py-2 xl:py-5 px-0 xl:px-4 -m-0.5 flex gap-2 items-center hover:text-white": true,
            "text-nav-text border-b-transparent": !isActive,
            "text-nav-hover xl:border-b-nav-active": isActive,
          });
          return cls;
        }}
        to={path}
        onClick={(ev) => {
          if (hasChildren) {
            ev.preventDefault();
          }

          return ev;
        }}
      >
        {title} {hasChildren && <PiCaretDownBold />}
      </NavLink>
      {hasChildren && isOpen && (
        <div className="fixed z-[51] bg-nav-bg float-left left-0 bg-clip-padding text-left shadow-lg [&[data-te-dropdown-show]]:block w-full">
          <div className="container-ab flex gap-4">{children}</div>
        </div>
      )}
    </div>
  );
};

export const NavBarLeftMenu = () => {
  return (
    <div className="flex items-center gap-6">
      <TopNavLink
        path="/organizations"
        title="Organisations"
        hasChildren={true}
      >
        <TopNavLink path="/organizations/companies" title="Companies" />
        <TopNavLink path="/organizations/investors" title="Investors" />
        <TopNavLink path="/organizations/esos" title="ESOs" />
        {/* <TopNavLink path="/organizations/funding-organizations" title="All funding organizations" /> */}
      </TopNavLink>
      <TopNavLink path="/deals" title="Deals" />
      <TopNavLink path="/comparison" title="Markets" />
      <TopNavLink path="/events" title="Events" />
      <TopNavLink path="/research" title="Research & Insights Hub" />
    </div>
  );
};

export const NavBarLeftMenuVertical = () => {
  return (
    <div className="flex gap-2 flex-col py-6">
      <TopNavLink path="/organizations/companies" title="Companies" />
      <TopNavLink path="/organizations/investors" title="Investors" />
      <TopNavLink path="/organizations/esos" title="ESOs" />
      {/* <TopNavLink path="/organizations/funding-organizations" title="All funding organizations" /> */}
      <TopNavLink path="/deals" title="Deals" />
      <TopNavLink path="/comparison" title="Markets" />
      <TopNavLink path="/events" title="Events" />
      <TopNavLink path="/research" title="Research & Insights Hub" />
    </div>
  );
};

export const NavBar = () => {
  const { session } = useAuth();
  const { setSidebarOpen, sidebarOpen } = useAppContext();
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

  return (
    <nav className="fixed bg-nav-bg w-full border-b-gray-200 border-b-2 z-50 max-w-[100vw] h-[60px] flex">
      <div className="container-ab flex items-center gap-8 lg:gap-16">
        <div className="flex items-center">
          <button
            className="xl:hidden text-xl text-nav-text pr-5"
            onClick={(ev) => {
              ev.preventDefault();
              setSidebarOpen(!sidebarOpen);
            }}
          >
            {sidebarOpen ? <RxCross1 /> : <RxHamburgerMenu />}
          </button>

          <Link to="/" className="py-2">
            <Logo />
          </Link>
        </div>
        <div className="hidden md:flex md:grow gap-2 lg:gap-4 items-center justify-end">
          <div className="hidden md:grow md:flex">
            <SearchAnywhereInput />
          </div>
          {/* <button className="flex items-center gap-2 py-3 xl:py-2 bg-ab-yellow rounded-md px-3 xl:px-8 font-semibold">
                        <FiPlus /> <span className="hidden xl:block">Suggest new</span>
                    </button> */}
          <RxDividerVertical className="text-3xl text-gray-500" />
          <Link
            to="/assistant"
            className="text-nav-text hover:text-nav-hover transition-colors"
            title="AI Assistant"
          >
            <RiRobot2Line className="text-2xl" />
          </Link>
          {/* <button className="rounded-md bg-ab-lightdarkgreen text-ab-lightgreen py-2.5 px-2.5 text-lg">
                        <FaBell />
                    </button> */}
          <ProfileMenu session={session} />

          {!get(session, "user.has_active_subscription", true) && (
            <HiMiniCheckBadge className="text-brand-highlight absolute top-1" />
          )}
        </div>
        <div className="flex grow justify-end items-center gap-4 md:hidden">
          <RxMagnifyingGlass
            className="text-2xl text-nav-text"
            onClick={(ev) => {
              ev.preventDefault();
              setIsMobileSearchOpen(true);
            }}
          />
          <Link
            to="/assistant"
            className="text-nav-text hover:text-nav-hover transition-colors"
            title="AI Assistant"
          >
            <RiRobot2Line className="text-2xl" />
          </Link>
          <ProfileMenu session={session} />
        </div>
      </div>
      {isMobileSearchOpen && (
        <AnimateIn
          from="absolute top-0 opacity-100 translate-x-96"
          to="absolute top-0 opacity-100 translate-x-0"
          duration={100}
        >
          <div className="absolute top-0 bg-nav-bg p-2 w-screen z-20">
            <div className="px-2">
              <div className="flex gap-4 items-center">
                <RxCross1
                  className="text-lg text-nav-hover"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setIsMobileSearchOpen(false);
                  }}
                />
                <SearchAnywhereInput />
              </div>
            </div>
          </div>
        </AnimateIn>
      )}
    </nav>
  );
};

const PersonaSwitcher = ({ currentPersona }: { currentPersona: string }) => {
  const personas = [
    { value: "FOUNDER", label: "Founder", path: "/" },
    { value: "INVESTOR", label: "Investor", path: "/" },
    { value: "ACCELERATOR", label: "Accelerator/Hub", path: "/" },
    { value: "ACADEMIA", label: "Academia", path: "/" },
    { value: "DFI_GOVT", label: "DFI/Govt", path: "/" },
    { value: "GENERIC", label: "Generic", path: "/" },
  ];

  const handlePersonaSwitch = (personaValue: string) => {
    // Save selected persona to localStorage for Briter users
    setCurrentPersona(personaValue);
    // Dispatch custom event to notify ApplicationContext of persona change
    window.dispatchEvent(new Event("personaChanged"));
  };

  return (
    <div className="border-t border-gray-200 pt-2 mt-2">
      <div className="px-4 py-2 text-xs text-gray-500 font-semibold">
        Switch Interface (Internal)
      </div>
      {personas.map((persona) => (
        <NavLink
          key={persona.value}
          to={persona.path}
          onClick={() => handlePersonaSwitch(persona.value)}
          className={`flex items-center gap-2 text-left w-full rounded-md px-4 py-2 text-sm ${
            currentPersona === persona.value
              ? "bg-nav-secondary text-nav-bg font-semibold"
              : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          {persona.label}
          {currentPersona === persona.value && (
            <span className="ml-auto">✓</span>
          )}
        </NavLink>
      ))}
    </div>
  );
};

const ProfileMenu = ({ session }: any) => {
  const { logout } = useAuth();

  const [state, setState] = useState({ isOpen: false });
  const ref = useRef(null);
  useOnClickOutside(ref, () => setState({ isOpen: false }));
  useEventListener(
    "mouseenter",
    () => {
      setState({ isOpen: true });
    },
    ref,
  );
  const full_name = [
    get(session, "user.first_name"),
    get(session, "user.other_names"),
  ].join("+");

  const currentPersona = getCurrentPersona(get(session, "user"));
  const isBriterUser = isBriterBridgesUser(get(session, "user.email", ""));

  return (
    <div className="relative flex flex-col items-center" ref={ref}>
      <button
        onClick={(ev) => {
          ev.preventDefault();
          setState({ isOpen: true });
        }}
      >
        <img
          src={get(
            session,
            "user.profile_image_url",
            `https://ui-avatars.com/api/?name=${full_name.replace(" ", "+")}`,
          )}
          alt={get(session, "user.first_name")}
          onError={(ev) => {
            //@ts-ignore
            ev.target.src = `https://ui-avatars.com/api/?name=${full_name.replace(
              " ",
              "+",
            )}`;
          }}
          className="h-10 w-10 border-4 object-cover border-nav-active rounded-full"
        />
      </button>
      {state.isOpen && (
        <div className="origin-top-right absolute right-0 mt-12 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 max-h-[80vh] overflow-y-auto">
          <div
            className=""
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="dropdown-button"
          >
            {/* <NavLink
              to="/profile"
              className="flex items-center gap-2 text-left w-full rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer"
            >
              <RxPerson /> Your profile
            </NavLink> */}

            <NavLink
              to="/settings"
              className="flex items-center gap-2 text-left w-full rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer"
            >
              <RxGear /> Settings
            </NavLink>

            {/* Persona Switcher for Briter Users */}
            {isBriterUser && (
              <PersonaSwitcher currentPersona={currentPersona} />
            )}

            <div className="border-t border-gray-200 mt-2">
              <button
                className="flex items-center gap-2 text-left w-full rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer"
                onClick={(ev) => {
                  ev.preventDefault();
                  logout();
                }}
              >
                <RxExit /> Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// or if using shadcn:
// import { cn } from "@/lib/utils"; // https://github.com/shadcn-ui/ui/blob/main/apps/www/lib/utils.ts

const AnimateIn = ({
  children,
  delay = 0,
  duration = 500,
  className = "",
  from,
  to,
  style,
  as = "div",
}: {
  from: string;
  to: string;
  children?: React.ReactNode;
  delay?: number;
  duration?: number;
  className?: string;
  style?: React.CSSProperties;
  as?: keyof React.ReactHTML;
}) => {
  const [animate, setAnimate] = useState(from);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    const mediaQueryChangeHandler = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };

    setPrefersReducedMotion(mediaQuery.matches);
    mediaQuery.addEventListener("change", mediaQueryChangeHandler);

    return () => {
      mediaQuery.removeEventListener("change", mediaQueryChangeHandler);
    };
  }, []);

  useEffect(() => {
    if (prefersReducedMotion) {
      // If the user prefers reduced motion, skip the animation
      setAnimate(to);
      return;
    }

    const timer = setTimeout(() => {
      setAnimate(to);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, to, prefersReducedMotion]);

  return React.createElement(
    as,
    {
      className: cn("transition-all ease-in-out", className, animate),
      style: {
        transitionDuration: prefersReducedMotion ? "0ms" : `${duration}ms`,
        ...style,
      },
    },
    children,
  );
};

export default AnimateIn;
